import styled from 'styled-components';
import { RoundedButton } from 'Components/Styles/Buttons/RoundedButton';

export const LightRoundedButton = styled(RoundedButton)`
    padding: 0.25rem 0.75rem;
    font-weight: 500;
`;